import React from "react";
import LoadingPanel from "../../../../../components/LoadingPanel";
import MappingProfile from "./MappingProfile";
import FieldMappingTable from "./FieldMappingTable";
import "./mapping-tab.scss";

const MappingTab = ({
  // Mapping Profiles
  mappingProfiles,
  activeProfile,
  setActiveProfile,
  mappingNames,
  handleAddMappingProfile,
  handleDuplicateMappingProfile,
  handleDeleteMappingProfile,
  handleSaveProfileName,
  handleMakeDefault,
  // Field Mappings
  fieldMappings,
  handleMappingChange,
  handleDefaultValueChange,
  handleDefaultValueChangeWithAutoSave,
  handleMapValues,
  handleSaveAll,
  // Filters
  statusFilter,
  setStatusFilter,
  mappingFilter,
  setMappingFilter,
  // Source Fields
  sourceFields,
  isLoadingProperties,
  // Solutions
  solutions,
  // UI State
  isSaving,
  isAutoSaving,
  isLoadingProfiles,
  isLoadingFieldMappings,
  isDuplicating,
  isDeleting,
  isMakingDefault,
  isCreatingProfile,
  isSavingProfileName,
  isEmptyMapping,
}) => {
  // Show loading overlay when switching profiles or loading initial data or performing actions
  const showLoadingOverlay = isLoadingProperties || isLoadingProfiles || isLoadingFieldMappings || isDuplicating || isDeleting || isMakingDefault || isCreatingProfile || isSavingProfileName || isAutoSaving;

  return (
    <>
      <MappingProfile
        mappingProfiles={mappingProfiles}
        activeProfile={activeProfile}
        setActiveProfile={setActiveProfile}
        mappingNames={mappingNames}
        onAddProfile={handleAddMappingProfile}
        onDuplicateProfile={handleDuplicateMappingProfile}
        onDeleteProfile={handleDeleteMappingProfile}
        onSaveProfileName={handleSaveProfileName}
        onMakeDefault={handleMakeDefault}
        onSaveAll={handleSaveAll}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        mappingFilter={mappingFilter}
        setMappingFilter={setMappingFilter}
        isEmptyMapping={isEmptyMapping}
      />

      {showLoadingOverlay && <LoadingPanel />}

      <FieldMappingTable
        fieldMappings={fieldMappings}
        statusFilter={statusFilter}
        mappingFilter={mappingFilter}
        onMappingChange={handleMappingChange}
        onDefaultValueChange={handleDefaultValueChange}
        onDefaultValueChangeWithAutoSave={handleDefaultValueChangeWithAutoSave}
        onMapValues={handleMapValues}
        sourceFields={sourceFields}
        solutions={solutions}
      />

      <div className="mapping-tab-actions">
        <button
          className="save-all-button"
          onClick={handleSaveAll}
          disabled={isSaving || showLoadingOverlay}
        >
          {isSaving ? "Saving..." : "Save All"}
        </button>
      </div>
    </>
  );
};

export default MappingTab;
